"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TickerConverter = void 0;
var _reactResponsive = require("react-responsive");
var _reactI18next = require("react-i18next");
var _reactHookForm = require("react-hook-form");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _ui = require("../../../../ui");
var _form = require("../../form");
var _hooks = require("../../../../../hooks");
var _fields = require("../../../../fields");
var _utils = require("../../../../../utils");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var InputCurrencyText = (0, _styledComponents.default)(_ui.MediumSpan)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
});
var TickerConverter = function TickerConverter() {
  var isTablet = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.md
  });
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransfers', 'libCommon']),
    t = _useTranslation.t;
  var _useFormContext = (0, _reactHookForm.useFormContext)(),
    control = _useFormContext.control;
  var props = (0, _hooks.useWithdrawContext)();
  return /*#__PURE__*/_react.default.createElement(_form.TickerConverter, null, /*#__PURE__*/_react.default.createElement(_form.TickerConverterFormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, {
    className: "d-flex justify-content-between"
  }, t('amount')), /*#__PURE__*/_react.default.createElement(_ui.InputGroupAbsolute, null, /*#__PURE__*/_react.default.createElement(_ui.InputGroupAddon, {
    addonType: "append"
  }, /*#__PURE__*/_react.default.createElement(InputCurrencyText, null, props.ticker)), /*#__PURE__*/_react.default.createElement(_fields.TickerNumberFormatInputField, {
    control: control,
    inputProps: {
      name: 'amount',
      onFocus: props.onAmountInputFocus,
      ticker: props.ticker
    }
  }))), !isTablet && /*#__PURE__*/_react.default.createElement(_form.TickerConverterEqualIcon, null), /*#__PURE__*/_react.default.createElement(_form.TickerConverterFormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('equivalent')), /*#__PURE__*/_react.default.createElement(_ui.InputGroupAbsolute, null, /*#__PURE__*/_react.default.createElement(_form.TickerSelectInputAddon, {
    value: props.fiatTicker,
    options: props.fiatTickers,
    onChange: props.setFiatTicker
  }), /*#__PURE__*/_react.default.createElement(_fields.TickerNumberFormatInputField, {
    control: control,
    inputProps: {
      name: 'fiatTickerAmount',
      onFocus: props.onFiatTickerAmountInputFocus,
      ticker: props.fiatTicker
    }
  })), !props.priceLoading && /*#__PURE__*/_react.default.createElement(_form.Rate, {
    ticker: props.ticker,
    convertedTicker: props.fiatTicker,
    price: props.price
  })));
};
exports.TickerConverter = TickerConverter;